/*******************************************************************************
Reports Actions

*******************************************************************************/
import { ROOT_URL } from '../../constants';
import { FETCH_CULTIVATION_REPORT } from './types';
import { error, success } from './chem_actions';
import axios from 'axios';
const $ = window.$;

/**
* fetchCultivationReport(): Fetches cultivation report
* @param {Object} opts: form options
* @param {Object} user: user object
* @returns {Array}
* @called-in: ['/components/reports/reports.js']
**/
export function fetchCultivationReport({ opts, user }) {
  if (opts.dateFrom === '' || opts.dateTo === '') return error('Please select two dates.');
  if (opts.type === '') return error('Please select a report type.');
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchCultivationReport`, {
      headers: { authorization: localStorage.getItem('token') },
      params: { opts, email: user.email }
    }).then((res) => {
      $('#preloader').css('display','none');
      let { msg, query } = res.data;
      success(msg);
      //console.log(res.data)
      dispatch({ type: FETCH_CULTIVATION_REPORT, payload: query });
    }).catch((e) => {
      $('#preloader').css('display','none');
      dispatch(error(`There was an issue fetching a report`))
    })
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/report_actions.js